import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";
import { BASPATH } from "../../config/appConfig";

 
const SmartCardComponent = Loadable({
  loader: () => import("./components/smartCard"),
  loading: Loading
});
 
export const routes = [
  {
    path: BASPATH + "smart-card",
    exact: true,
    name: "smartCard",
    element: SmartCardComponent
  },
];

export * from "../auth/components";
